import { NotificationTypesEnum } from "../enums/NotificationTypesEnum";
import { AppNotification } from "./AppNotification";

export class OneTimeCodeNotification extends AppNotification {
    notificationType: NotificationTypesEnum = NotificationTypesEnum.OneTimeCode;
    category: OneTimeCodeNotificationsType;

    constructor(data: any) {
        super(data);
        if (data.Category) this.category = data.Category;
    }
}

export enum OneTimeCodeNotificationsType {
    SmartLockActivation,
    NonceReceived,
    DuressReceived,
}

export function oneTimeCodeNotificationsTypeToLabel(val: OneTimeCodeNotificationsType): string {
    let res = "";
    switch (val) {
        case OneTimeCodeNotificationsType.SmartLockActivation:
            res = "enum.onetimecode_notifications_type.smartlock_activation";
            break;
        case OneTimeCodeNotificationsType.NonceReceived:
            res = "enum.onetimecode_notifications_type.nonce_received";
            break;
        case OneTimeCodeNotificationsType.DuressReceived:
            res = "enum.onetimecode_notifications_type.duress_received";
            break;
        default:
            res = "common.unknown";
            break;
    }
    return res;
}
